<template lang="pug">
div.container
  section#container.container
    //-動画撮影のエリア
    div#interactive.viewport
      video(width="100%")
      div.overlay
        transition(name="fade")
          div.use-camera(v-if="overlay && useCamera")
            p.desc 枠にバーコードが収まるよう<br>カメラを向けてください
          div.no-use-camera(v-else-if="useCamera===false")
            p.title ライブカメラが無効です
            p.desc
              | スマートフォン本体またはブラウザの設定で
              | カメラへのアクセスを有効にし、
              | この画面を再度読み込んでください。<br><br>
              | または、「写真選択」から撮影済みのバーコード写真を選択し、読み取りできます。
          div.detect-area(v-if='detectArea')
      div.overlay-notice(v-if="detectNotice")
          div.detect-notice
            p.title ピントがあわないときは
            ul.notice
              li.desc 距離が近すぎるとピントが合わない場合があります。
              li.desc オートフォーカス機能が別の被写体をとらえているかもしれません。一度カメラを離してみましょう。
              li.desc 明るいところで撮影ください。
  div.change-stream-btn-area(v-if="userDevice==='Android'")
    button.btn-change-stream(@click="useImageStream")
      font-awesome-icon.fa-cam-icon(icon="camera")
      span &ensp;&ensp;写真選択に切り替え
  div.favorite-btn-area
    button.btn-favorite(@click="goFavorite")
      font-awesome-icon(:style="heartStyle" icon="heart")
      span &ensp;チェックした商品をみる
</template>

<script>
import quagga from "quagga";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCamera, faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "LiveStream",
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    userDevice: {
      type: String,
      requires: true,
      default: ""
    }
  },
  data() {
    library.add(faCamera);
    library.add(faHeart);
    return {
      quagga: null,
      heartStyle: {
        color: "#53433e",
        stroke: "#ffffff",
        strokeWidth: "60px"
      },
      overlay: false,
      useCamera: null,
      detectArea: false,
      detectNotice: false
    };
  },
  mounted() {
    this.quagga = quagga;
    const state = {
      inputStream: {
        type: "LiveStream",
        constraints: {
          // width: 1920,
          // height: 1080,
          // aspectRatio: { min: 1, max: 3 }
          width: {min: 640},
          height: {min: 480},
          aspectRatio: {min: 1, max: 100},
          facingMode: "environment"
          }
      },
      locator: {
        patchSize: "medium",
        halfSample: true
      },
      numOfWorkers: 4,
      frequency: 8,
      decoder: {
        readers: [
          {
            format: "ean_reader",
            config: {}
          }
        ]
      },
      locate: true
    };

    this.quagga.init(state, err => {
      if (!err) {
        this.quagga.start();
        this.useCamera = true;
        // 動画読み取りの案内をカメラ起動時に一定時間表示
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
          this.detectArea = true;
        }, 3000);
        // 注意事項をカメラ起動後一定時間経過後に表示
        setTimeout(() => {
          this.detectNotice = true;
        }, 10000);
      } else {
        this.useCamera = false;
      }
    });
    this.quagga.onDetected(result => {
      this.quagga.stop();
      this.quagga.offDetected();
      this.$router.push({
        name: "result",
        params: { jan: result.codeResult.code, sendEvent: true }
      });
    });
  },
  methods: {
    goFavorite() {
      this.$router.push({ name: "favorite" });
    },
    useImageStream() {
      this.$emit("changeImageStream");
    }
  }
};
</script>

<style lang="sass" scoped>
.fa-cam-icon
  font-size: 1.6em

#container
  width: auto

#interactive.viewport
  padding: 6vh 10vw
  width: 41vh
  height: 55vh
  margin: auto
  video
    object-fit: cover
    float: left
    width: 80%
    height: 100%
    border-radius: 1.5vw
    overflow: hidden
    background-color: black
.overlay-notice
  text-align: center
  color: white
  position: absolute
  top: 42vh
  left: 0
  height: auto
  width: 100%
  display: flex
  align-items: center
  justify-content: center
  .detect-notice
    margin-top: 5vh
    background-color: black
    opacity: 0.74
    width: 100%
    .title
      font-size: 10px
      padding: 0px
      margin: 2px 0px
    ul
      margin: 5px 10px
    .desc
      text-align: left
      font-size: 8px
      width: 100%;

.overlay
  text-align: center
  color: white
  position: absolute
  top: 20vh
  left: 0
  height: auto
  width: 100%
  display: flex
  align-items: center
  justify-content: center
  .use-camera
    margin-top: 5vh
    background-color: black
    opacity: 0.74
    width: 100%
  .no-use-camera
    width: 60%
    margin:auto
    .title
      margin: 0px
      font-size: 16px
      font-weight: bold
    .desc
      text-align: left
      font-size: 12px
      width: 100%;
  .fade-leave-active
    transition: opacity 1s
  .fade-leave-to
    opacity: 0
  .detect-area
    height: 25vh
    width: 50%
    border: 2px solid #0000ff

.change-stream-btn-area
  margin-top: 2vh
  .btn-change-stream
    background: none
    color: #53433e
    align-items: center
    display: flex
    justify-content: center
    margin: auto
    border-radius: 10px
    width: 76vw
    height: 8vmax
    font-size: 2.5vmax

.favorite-btn-area
  margin-top: 5%
  .btn-favorite
    align-items: center
    display: flex
    justify-content: center
    margin: auto
    border-radius: 2em
    width: 60vw
    height: 6vmax
    font-size: 2vmax

@media (max-width: 603px)
  #interactive.viewport
    padding: 6vh 0vw 0px
    width: 41vh
    height: 55vh
    overflow: hidden
    margin: auto
    video
      object-fit: cover
      border-radius: 1.5vw
      width: 100%
      height: 100%
</style>
